import { useState } from 'react';
import { LogOut, Keyboard } from 'lucide-react';
import { Sidebar } from '@/components/Sidebar';
import { ApplicantToggle } from '@/components/ApplicantToggle';
import { InterviewBanner } from '@/components/InterviewBanner';
import { ThemeToggle } from '@/components/ThemeToggle';
import { HelpModal } from '@/components/HelpModal';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';
import { useAuth } from '@/contexts/AuthContext';
import type { ReactNode } from 'react';

export function DashboardLayout({ children }: { children: ReactNode }) {
  const { logout } = useAuth();
  const [helpOpen, setHelpOpen] = useState(false);
  useKeyboardShortcuts({
    onHelp: () => setHelpOpen(true),
    onSearch: () => {
      const el = document.querySelector<HTMLInputElement>('[data-app-search]');
      el?.focus();
    },
  });
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex flex-1 flex-col">
        <InterviewBanner />
        <header className="flex h-14 items-center justify-between border-b border-gray-200 bg-white px-4 dark:border-gray-800 dark:bg-gray-900">
          <div />
          <div className="flex items-center gap-3">
            <ApplicantToggle />
            <ThemeToggle />
            <button
              onClick={() => setHelpOpen(true)}
              title="Keyboard shortcuts (?)"
              className="rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
            >
              <Keyboard className="h-4 w-4" />
            </button>
            <button
              onClick={logout}
              title="Sign out"
              className="rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </header>
        <main className="flex-1 overflow-y-auto p-6">{children}</main>
      </div>
      <HelpModal open={helpOpen} onClose={() => setHelpOpen(false)} />
    </div>
  );
}
